export default [
  {
    path: '/loanDetails',
    name: 'LoanDetails',
    component: () => import('@/views/loan/loanDetails.vue'),
    meta: { pageName: 'LoanDetails-refused' }
  },
  {
    path: '/applicationSub',
    name: 'ApplicationSub',
    component: () => import('@/views/loan/applicationSub.vue'),
    meta: { pageName: 'ApplicationSub-refused' }
  }
]
